import _Vue from 'vue';
import Toast from './Toast.vue';
import events from './events';

const ToastPlugin = {
  install(Vue: typeof _Vue) {
    if (this.installed) return;
    this.installed = true;

    Vue.component('vue-toast', Toast);

    Vue.prototype.$toast = (params: any) => {
      let payload = JSON.parse(JSON.stringify(params));
      if (typeof payload === 'string') {
        payload = { message: params };
      }

      if (typeof payload === 'object') {
        events.$emit('show', payload);
      }
    };

    Vue.prototype.$toast.info = (msg: string) => events.$emit('info', msg);
    Vue.prototype.$toast.error = (msg: string) => events.$emit('error', msg);
    Vue.prototype.$toast.warning = (msg: string) => events.$emit('warning', msg);
    Vue.prototype.$toast.success = (msg: string) => events.$emit('success', msg);
  },
};

export default ToastPlugin;
